import { Container, BottomNavigationAction, Paper, BottomNavigation } from '@material-ui/core';
import { makeStyles } from '@material-ui/styles';
import React, { useState } from 'react';
import { connect } from 'react-redux';
import Page from 'src/components/Page';
import Header from 'src/components/Header';
import { useTranslation } from 'react-i18next';
import { getTasksRequest } from '../../store/actions/taskActions';
import IletisimDetay from './ContactDetail';
import BottomRouters from 'src/components/BottomRouters';
const useStyles = makeStyles((theme) => ({
  root: {
    paddingTop: theme.spacing(3),
    paddingBottom: theme.spacing(3)
  },
  IletisimDetay: {
    marginTop: theme.spacing(1)
  },
}));


const ServisIletisim = (props) => {
  const classes = useStyles();
  const { t } = useTranslation('service_contact');
  return (
    <Page className={classes.root} title={'Sirius Tech'}>
      <Container maxWidth="lg">
        <Header />
        <IletisimDetay className={classes.IletisimDetay} />
      </Container>
      <BottomRouters/>
    </Page>
  );
};


export default connect(
  (state) => ({ tasks: state.tasks1 }),
  {
    getTasksRequest
  }
)(ServisIletisim);
